import script from "./DocPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DocPage.vue?vue&type=script&setup=true&lang=js"

import "./DocPage.vue?vue&type=style&index=0&id=3e700b50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e700b50"]])

export default __exports__